import intl from 'react-intl-universal';
import { Input } from 'antd';
import { default as Addrs } from './addr/index';
import GlobalAddr from './globalAddr/index';
import { default as Upload } from './upload/index';
import AddrSelectDate from './addr/dateTime';
import ChangeGood from './ChangeGood';
import RepairGood from './RepairGood';
import RefundGood from './RefundGood';
import ConsultGood from './ConsultGood';
import ErrorJudge from './ErrorJudge';
import DutyJudge from './DutyJudge';
import ImportantOrder from './ImportantOrder';
import Editor from './editor';
import Order from './Order';

import style from './index.less';

import { default as Category } from './category';
import type { ProFormProps } from '@ant-design/pro-components';
// import { ProFormSelect } from '@ant-design/pro-components';
import { default as GoodsAttribute } from './GoodsAttribute';

const getValueMap = (props: ProFormProps) => ({
    // 去掉前后空格
    text: {
        render: (text: any) => {
            return text || '-';
        },
        renderFormItem: (schema: any, config: any, ...ret: any[]) => {
            return config?.renderFormItem ? (
                config.renderFormItem(schema, config, ...ret)
            ) : (
                <>
                    <Input
                        {...config?.fieldProps}
                        placeholder={
                            config?.fieldProps?.placeholder ||
                            intl.get('请输入')
                        }
                        onBlur={(e) => {
                            e.target.value = e.target.value?.trim() || '';
                            config?.fieldProps?.onChange?.(e);
                        }}
                    />

                    {config?.fieldProps?.tips && (
                        <>{config?.fieldProps?.tips}</>
                    )}
                </>
            );
        },
    },
    ImportantOrder: {
        render: (schema: any, config: any) => {
            return (
                <ImportantOrder
                    {...config?.fieldProps}
                    readonly
                />
            );
        },
        renderFormItem: (schema: any, config: any) => {
            return <ImportantOrder {...config?.fieldProps} />;
        },
    },
    DutyJudge: {
        render: (schema: any, config: any) => {
            return (
                <DutyJudge
                    {...config?.fieldProps}
                    readonly
                />
            );
        },
        renderFormItem: (schema: any, config: any) => {
            return <DutyJudge {...config?.fieldProps} />;
        },
    },
    ErrorJudge: {
        render: (schema: any, config: any) => {
            return (
                <ErrorJudge
                    {...config?.fieldProps}
                    readonly
                />
            );
        },
        renderFormItem: (schema: any, config: any) => {
            return <ErrorJudge {...config?.fieldProps} />;
        },
    },
    ConsultGood: {
        render: (schema: any, config: any) => {
            return (
                <ConsultGood
                    {...config?.fieldProps}
                    readonly
                />
            );
        },
        renderFormItem: (schema: any, config: any) => {
            return <ConsultGood {...config?.fieldProps} />;
        },
    },
    RepairGood: {
        render: (schema: any, config: any) => {
            return (
                <RepairGood
                    {...config?.fieldProps}
                    readonly
                    orderCreatedTime={props?.initialValues?.createdTime}
                />
            );
        },
        renderFormItem: (schema: any, config: any) => {
            return <RepairGood {...config?.fieldProps} />;
        },
    },
    RefundGood: {
        render: (schema: any, config: any) => {
            return (
                <RefundGood
                    {...config?.fieldProps}
                    readonly
                    orderCreatedTime={props?.initialValues?.createdTime}
                />
            );
        },
        renderFormItem: (schema: any, config: any) => {
            return <RefundGood {...config?.fieldProps} />;
        },
    },
    ChangeGood: {
        render: (schema: any, config: any) => {
            return (
                <ChangeGood
                    {...config?.fieldProps}
                    readonly
                    orderCreatedTime={props?.initialValues?.createdTime}
                />
            );
        },
        renderFormItem: (schema: any, config: any) => {
            return <ChangeGood {...config?.fieldProps} />;
        },
    },
    category: {
        render: (schema: any, config: any) => {
            return (
                <Category
                    {...config?.fieldProps}
                    readonly
                />
            );
        },
        renderFormItem: (schema: any, config: any) => {
            return <Category {...config?.fieldProps} />;
        },
    },
    goodsAttribute: {
        render: (schema: any, config: any) => {
            return (
                <GoodsAttribute
                    {...config?.fieldProps}
                    readonly
                />
            );
        },
        renderFormItem: (schema: any, config: any) => {
            return <GoodsAttribute {...config?.fieldProps} />;
        },
    },
    editor: {
        render: (schema: any, config: any) => {
            return (
                <Editor
                    {...config?.fieldProps}
                    readonly
                />
            );
        },
        renderFormItem: (schema: any, config: any) => {
            return <Editor {...config?.fieldProps} />;
        },
    },

    // 省市区
    addr: {
        render: (text: any, config: any) => {
            return (
                <Addrs
                    {...config?.fieldProps}
                    {...props}
                    readonly
                />
            );
        },
        renderFormItem: (schema: any, config: any) => {
            return (
                <Addrs
                    {...config?.fieldProps}
                    {...props}
                />
            );
        },
    },
    addrSelectDate: {
        render: (text: any) => {
            return text;
        },
        renderFormItem: (schema: any, config: any) => {
            return <AddrSelectDate {...config?.fieldProps} />;
        },
    },
    // 国际化地址组件
    globalAddr: {
        render: (text: any, config: any) => {
            return (
                <GlobalAddr
                    {...config?.fieldProps}
                    {...props}
                    readonly
                />
            );
        },
        renderFormItem: (schema: any, config: any) => {
            return (
                <GlobalAddr
                    {...config?.fieldProps}
                    {...props}
                />
            );
        },
    },
    upload: {
        render: (text: any, config: any) => {
            return (
                <Upload
                    {...config?.fieldProps}
                    readonly
                />
            );
        },
        renderFormItem: (text: any, config: any) => {
            return <Upload {...config?.fieldProps} />;
        },
    },
    groupTitle: {
        render: (text: any, config: any) => {
            const {
                fieldProps: { title },
            } = config;
            return <div className={style.formItem_groupTitle}>{title}</div>;
        },
        renderFormItem: (text: any, config: any) => {
            const {
                fieldProps: { title, subheading },
            } = config;
            return (
                <div>
                    <div className={style.formItem_groupTitle}>{title}</div>
                    {subheading && (
                        <div className={style.subheading}>{subheading}</div>
                    )}
                </div>
            );
        },
    },
    Order: {
        render: (text: any, config: any) => {
            console.log(text, config);
            // const {
            //     fieldProps: { title },
            // } = config;
            return (
                <Order
                    {...config?.fieldProps}
                    readonly
                ></Order>
            );
        },
        renderFormItem: (text: any, config: any, form) => {
            console.log(text, config, form);
            // const {
            //     fieldProps: { title },
            // } = config;
            return <Order {...config?.fieldProps}></Order>;
        },
    },
});

export default getValueMap;

export type ValueType =
    | 'category'
    | 'addr'
    | 'globalAddr'
    | 'addrSelectDate'
    | 'upload'
    | 'editor'
    | 'ChangeGood'
    | 'RefundGood'
    | 'RepairGood'
    | 'ConsultGood'
    | 'ErrorJudge'
    | 'DutyJudge'
    | 'ImportantOrder'
    | 'groupTitle'
    | 'custormFormList'
    | 'goodsAttribute'
    | 'Order';
// | 'select';
